import { cn } from "@/lib/utils";
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-primary/10", className)} {...props} data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx" />;
}
export { Skeleton };